import { type Theme } from "@mui/material/styles";

import { type DialogIntent } from "ui/dialog/dialog.types";

import Icons from "assets";

export type DialogStatusIntent = Exclude<DialogIntent, "inherit">;

export const CONTAINER_PADDING = 24;

export const CONTAINER_SPACING = 16;

export const DETAILS_SPACING = 16;

/**
 * Room inside the scrolling body for MUI's focus halos and checkbox ripples, which a scroll container
 * clips on all four edges. Paid back with an equal negative margin, so it costs no layout.
 */
export const BODY_HALO = 10;

export const RAIL_WIDTH = 8;

export const RAIL_TO_GLYPH = 12;

export const GLYPH_TO_CONTENT = 16;

export const ICON_SIZE = 24;

export const HEADING_ICON_SPACING = 8;

/** Headline to the step indicator: `dialog/body/container/heading/spacing`. */
export const HEADING_SPACING = 2;

export const ACTIONS_PADDING_TOP = 16;

export const ACTIONS_SPACING = 12;

export const CLOSE_INSET = 12;

export const CLOSE_BUTTON_SIZE = 32;

export const HEADING_PADDING_RIGHT =
  CLOSE_INSET + CLOSE_BUTTON_SIZE - CONTAINER_PADDING + HEADING_ICON_SPACING;

/** The rail is the paper's left border, so it eats into the left padding instead of adding to it. */
export const PADDING_LEFT_BASIC = CONTAINER_PADDING - RAIL_WIDTH;

export const PADDING_LEFT_WITH_RAIL = RAIL_TO_GLYPH;

export const MEDIUM_MAX_HEIGHT = "80vh";

export const RAIL_COLOR: Record<DialogStatusIntent, (theme: Theme) => string> = {
  success: (theme) => theme.palette.success.main,
  warning: (theme) => theme.palette.warning.main,
  error: (theme) => theme.palette.error.main,
};

export const STATUS_GLYPH: Record<DialogStatusIntent, (typeof Icons)[keyof typeof Icons]> = {
  success: Icons.CheckCircle,
  warning: Icons.WarningIndicator,
  error: Icons.InfoIndicator,
};
